import { AppBase } from './../app.base';
import { getWorld, WorldList } from './WorldInfo';
import { CookiesStatic } from "node_modules/@types/js-cookie/index";
import { LevelInfo } from "./LevelInfo";

declare const Cookies: CookiesStatic

export class UserRecord extends PIXI.utils.EventEmitter {

    static EVENT = {
        LEVEL_RECORD_CHANGE: 'levelRecordChange'
    };

    private json: { [key: string]: any } = {};

    constructor() {
        super();
        this.refresh();
    }

    refresh(): void {
        this.json = Cookies.getJSON('userRecord') || {};
        console.log('cookie loaded: ' + JSON.stringify(this.json));
    }

    save(): void {
        Cookies.set('userRecord', this.json);
    }

    setAudioPlayed(audio: string): void {
        this.json.audios = this.json.audios || {};
        if (!this.json.audios[audio]) {
            this.json.audios[audio] = {};
            this.save();
        }
    }

    isAudioPlayed(audio: string): boolean {
        let audios = this.json.audios || {};
        return audios[audio];
    }

    getLevelRecord(level: string): LevelRecord {
        let levels: any = this.json.levels || {};
        let json: { [key: string]: any } = levels[level];
        if (json) {
            return new LevelRecord(level, json);
        }
        return null;
    }

    setLevelRecord(level: string, record: LevelRecord): boolean {
        if (record) {
            let currentRecord: LevelRecord = this.getLevelRecord(level);
            if (currentRecord == null || currentRecord.stars < record.stars || currentRecord.time > record.time) {
                let levels: any = this.json.levels || {};
                levels[level] = record.json;
                this.json.levels = levels;
                this.save();
                this.emit(UserRecord.EVENT.LEVEL_RECORD_CHANGE);
                return true;
            }
        }
        return false;
    }

    hasLevelRecord(level: string): boolean {
        let levels: { [key: string]: any } = this.json.levels || {};
        return levels.hasOwnProperty(level) && levels[level];
    }

    isWorldLocked(_worldCode: string): boolean {
        if (AppBase.debug) {
            return false;
        } else {
            let worldIndex: number = getWorld(_worldCode).index;
            return worldIndex > 0 && !this.isWorldComplete(WorldList[worldIndex-1].code);
        }
    }

    isWorldComplete(worldCode: string): boolean {
        let level: LevelInfo = LevelInfo.getLevel(worldCode, 0);
        return this.hasLevelRecord(level.level) || getWorld(worldCode).index <= 0;
    }

    getWorldProgress(worldCode: string): number {
        let stars: number = 0;
        for (let i = 0; i <= 10; ++i) {
            let level: LevelInfo = LevelInfo.getLevel(worldCode, i);
            let record: LevelRecord = this.getLevelRecord(level.level);
            if (record) {
                stars += record.stars;
            }
        }
        // 33 stars total for a world ( 10 lvs + challenge ) * 3
        return stars / 33;
    }

    isLevelLocked(_level: string): boolean {
        if (AppBase.debug) {
            return false;
        } else {
            let info: LevelInfo = LevelInfo.fromString(_level);
            if (info.index == 1) {
                return false;
            }
            if (info.index == 0) {
                return !this.hasLevelRecord(LevelInfo.getLevel(info.worldCode, 10).level);
            }
            return !this.hasLevelRecord(info.getNeighbor(-1).level);
        }
    }
}

export class LevelRecord {

    constructor(public level: string, public json: { [key: string]: any }) {

    }

    public get stars(): number {
        return this.json.stars || 0;
    }

    public set stars(value: number) {
        this.json.stars = value;
    }

    public get time(): number {
        return this.json.time || 0;
    }

    public set time(value: number) {
        this.json.time = value;
    }

}

export const userRecord: UserRecord = new UserRecord();


// WEBPACK FOOTER //
// ./src/data/UserRecord.ts